import React from "react";
import styled from "styled-components";

const StepContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-family: "Inter", sans-serif;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: ${(props) => (props.active ? "#2563eb" : "#9ca3af")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background: ${(props) => (props.active ? "#2563eb" : "#d1d5db")};
  border-radius: 50%;
  margin: 0 0.5rem;
`;

const Line = styled.div`
  width: 24px;
  height: 2px;
  background: #d1d5db;
  margin: 0 0.5rem;
`;

const StepProgress = ({ current }) => {
  return (
    <StepContainer>
      <Step active={current === 1}>Step 1</Step>
      <Dot active={current === 1} />
      <Line />

      <Step active={current === 2}>Step 2</Step>
      <Dot active={current === 2} />
      <Line />

      <Step active={current === 3}>Step 3</Step>
      <Dot active={current === 3} />
    </StepContainer>
  );
};

export default StepProgress;
